/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CustomTagControllerCreateCustomTagGroupBodyRequest {
  /** 고객 태그 유형 이름 */
  name: string;
}

export interface CustomTagControllerCreateCustomTagGroupResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 유형 ID */
    id: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerUpdateCustomTagGroupNameBodyRequest {
  /** 고객 태그 유형 ID */
  id: string;
  /** 고객 태그 유형 이름 */
  name: string;
}

export interface CustomTagControllerUpdateCustomTagGroupNameResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 유형 ID */
    id: string;
    /** 고객 태그 유형 이름 */
    name: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerUpdateCustomTagGroupStatusBodyRequest {
  /** 고객 태그 유형 ID */
  id: string;
  /** 고객 태그 유형 사용 여부(토글) */
  isActive: boolean;
}

export interface CustomTagControllerUpdateCustomTagGroupStatusResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 유형 ID */
    id: string;
    /** 고객 태그 유형 사용 여부(토글) */
    isActive: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerRemoveCustomTagGroupBodyRequest {
  /** 고객 태그 유형 ID */
  id: string;
}

export interface CustomTagControllerRemoveCustomTagGroupResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 삭제 성공 여부 */
    isDeletedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerGetCustomTagGroupAndTagListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 유형 ID */
    _id: string;
    /** 고객 태그 유형 이름 */
    name: string;
    /** 병원 ID */
    hospitalID: string;
    /** 삭제 여부 */
    isRemoved: boolean;
    /** 고객 태그 유형 사용 여부 */
    isActive: boolean;
    /** 작성자 ID */
    writerID: string;
    /** 수정자 ID */
    modifierID: string;
    /** 생성 일시 */
    createdAt: string;
    /** 수정 일시 */
    updatedAt: string;
    /** @default [] */
    customTags?: {
      /** 고객 태그 ID */
      _id: string;
      /** 고객 태그 이름 */
      name: string;
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerCreateCustomTagBodyRequest {
  /** 고객 태그 유형 ID */
  customTagGroupID: string;
  /** 고객 태그 이름 */
  name: string;
}

export interface CustomTagControllerCreateCustomTagResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 ID */
    id: string;
    /** 고객 태그 이름 */
    name: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerUpdateCustomTagNameBodyRequest {
  /** 고객 태그 유형 ID */
  customTagGroupID: string;
  /** 고객 태그 ID */
  id: string;
  /** 새 고객 태그 이름 */
  name: string;
}

export interface CustomTagControllerUpdateCustomTagNameResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 고객 태그 ID */
    id: string;
    /** 고객 태그 이름 */
    name: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CustomTagControllerRemoveCustomTagBodyRequest {
  /** 고객 태그 ID */
  id: string;
}

export interface CustomTagControllerRemoveCustomTagResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 삭제 성공 여부 */
    isDeletedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type CustomTagControllerCreateCustomTagGroupData = CustomTagControllerCreateCustomTagGroupResponse;

export type CustomTagControllerUpdateCustomTagGroupNameData = CustomTagControllerUpdateCustomTagGroupNameResponse;

export type CustomTagControllerUpdateCustomTagGroupStatusData = CustomTagControllerUpdateCustomTagGroupStatusResponse;

export type CustomTagControllerRemoveCustomTagGroupData = CustomTagControllerRemoveCustomTagGroupResponse;

export type CustomTagControllerGetCustomTagGroupAndTagData = CustomTagControllerGetCustomTagGroupAndTagListResponse;

export type CustomTagControllerCreateCustomTagData = CustomTagControllerCreateCustomTagResponse;

export type CustomTagControllerUpdateCustomTagNameData = CustomTagControllerUpdateCustomTagNameResponse;

export type CustomTagControllerRemoveCustomTagData = CustomTagControllerRemoveCustomTagResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerCreateCustomTagGroup
     * @summary 고객 태그 유형 추가
     * @request POST:/v3/api/custom-tag/group
     * @secure
     * @response `200` `CustomTagControllerCreateCustomTagGroupData` success
     */
    customTagControllerCreateCustomTagGroup: (
      data: CustomTagControllerCreateCustomTagGroupBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerCreateCustomTagGroupData, any>({
        path: `/v3/api/custom-tag/group`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 유형 이름 수정
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerUpdateCustomTagGroupName
     * @summary 고객 태그 유형 이름 수정 ts
     * @request PATCH:/v3/api/custom-tag/group/update/name
     * @secure
     * @response `200` `CustomTagControllerUpdateCustomTagGroupNameData` success
     */
    customTagControllerUpdateCustomTagGroupName: (
      data: CustomTagControllerUpdateCustomTagGroupNameBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerUpdateCustomTagGroupNameData, any>({
        path: `/v3/api/custom-tag/group/update/name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 유형 상태 수정(isActive)
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerUpdateCustomTagGroupStatus
     * @summary 고객 태그 유형 상태 수정 ts
     * @request PATCH:/v3/api/custom-tag/group/update/status
     * @secure
     * @response `200` `CustomTagControllerUpdateCustomTagGroupStatusData` success
     */
    customTagControllerUpdateCustomTagGroupStatus: (
      data: CustomTagControllerUpdateCustomTagGroupStatusBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerUpdateCustomTagGroupStatusData, any>({
        path: `/v3/api/custom-tag/group/update/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 유형 삭제
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerRemoveCustomTagGroup
     * @summary 고객 태그 유형 삭제 ts
     * @request POST:/v3/api/custom-tag/group/remove
     * @secure
     * @response `200` `CustomTagControllerRemoveCustomTagGroupData` success
     */
    customTagControllerRemoveCustomTagGroup: (
      data: CustomTagControllerRemoveCustomTagGroupBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerRemoveCustomTagGroupData, any>({
        path: `/v3/api/custom-tag/group/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 유형 및 태그 유형에 속하는 고객 태그 리스트 조회
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerGetCustomTagGroupAndTag
     * @summary 고객 태그 유형 및 태그 유형에 속하는 고객 태그 리스트 조회 ts
     * @request GET:/v3/api/custom-tag/groups-with-tags
     * @secure
     * @response `200` `CustomTagControllerGetCustomTagGroupAndTagData` success
     */
    customTagControllerGetCustomTagGroupAndTag: (params: RequestParams = {}) =>
      this.request<CustomTagControllerGetCustomTagGroupAndTagData, any>({
        path: `/v3/api/custom-tag/groups-with-tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 추가
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerCreateCustomTag
     * @summary 고객 태그 추가 ts
     * @request POST:/v3/api/custom-tag
     * @secure
     * @response `200` `CustomTagControllerCreateCustomTagData` success
     */
    customTagControllerCreateCustomTag: (
      data: CustomTagControllerCreateCustomTagBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerCreateCustomTagData, any>({
        path: `/v3/api/custom-tag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 이름 수정
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerUpdateCustomTagName
     * @summary 고객 태그 이름 수정 ts
     * @request PATCH:/v3/api/custom-tag/update/name
     * @secure
     * @response `200` `CustomTagControllerUpdateCustomTagNameData` success
     */
    customTagControllerUpdateCustomTagName: (
      data: CustomTagControllerUpdateCustomTagNameBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerUpdateCustomTagNameData, any>({
        path: `/v3/api/custom-tag/update/name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 고객 태그 삭제
     *
     * @tags V3-CustomTag
     * @name CustomTagControllerRemoveCustomTag
     * @summary 고객 태그 삭제 ts
     * @request POST:/v3/api/custom-tag/remove
     * @secure
     * @response `200` `CustomTagControllerRemoveCustomTagData` success
     */
    customTagControllerRemoveCustomTag: (
      data: CustomTagControllerRemoveCustomTagBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomTagControllerRemoveCustomTagData, any>({
        path: `/v3/api/custom-tag/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
